import { Home, Send } from "lucide-react";
import { PageLayout } from "@/components/PageLayout";
import { PageHero } from "@/components/blocks/PageHero";
import { SectionHeading } from "@/components/blocks/SectionHeading";
import { CTABand } from "@/components/blocks/CTABand";
import { FaqList } from "@/components/blocks/FaqList";
import { FAQ_GROUPS } from "@/lib/faq";
import { ROUTE_CONTACT, ROUTE_DEMO } from "@/lib/brand";

const SIDEBAR_ITEMS = [
  { id: "top", label: "Start", icon: Home },
  ...FAQ_GROUPS.map((g) => ({ id: g.id, label: g.title, icon: g.icon })),
  { id: "cta", label: "Kontakt", icon: Send },
];

export default function Faq() {
  return (
    <PageLayout sidebarItems={SIDEBAR_ITEMS} title="Häufige Fragen" testId="faq-main">
      <PageHero
        eyebrow="Häufige Fragen"
        titleLines={["Was Vereine und", "Unternehmen"]}
        titleAccent="zuerst fragen."
        lead="Von der Frage, was MatchGate überhaupt ist, über das Messen bis zu Preis und Provision. Eure Frage ist nicht dabei? Schreibt uns, wir antworten in der Regel innerhalb eines Werktages."
        primary={{ label: "Kontakt aufnehmen", to: ROUTE_CONTACT }}
        secondary={{ label: "Zu den Fragen", href: `#${FAQ_GROUPS[0].id}` }}
      />

      {FAQ_GROUPS.map((group, i) => (
        <section
          key={group.id}
          id={group.id}
          data-testid={`faq-${group.id}-section`}
          className="relative py-20 lg:py-28 border-t border-white/[0.06]"
        >
          <div className="px-6 md:px-10 lg:px-16 grid lg:grid-cols-12 gap-10 lg:gap-16">
            <div className="lg:col-span-5 xl:col-span-4">
              <div className="lg:sticky lg:top-sticky">
                <SectionHeading
                  eyebrow={`Thema ${i + 1} von ${FAQ_GROUPS.length}`}
                  title={group.title}
                  lead={group.lead}
                  className="max-w-sm mb-0"
                />
              </div>
            </div>
            <div className="lg:col-span-7 xl:col-span-8">
              <FaqList items={group.items} />
            </div>
          </div>
        </section>
      ))}

      <CTABand
        title="Eure Frage war nicht "
        accent="dabei"
        tail="?"
        lead="Schreibt uns, was ihr wissen wollt. Oder probiert in der Demo selbst aus, wie ein Sponsoring auf MatchGate aussieht."
        primary={{ label: "Kontakt aufnehmen", to: ROUTE_CONTACT }}
        secondary={{ label: "Demo ansehen", to: ROUTE_DEMO }}
      />
    </PageLayout>
  );
}
